<template>
  <div class="main">
    <main class="container alianca-content">
      <section class="row">
        <div class="main-content col-12">
          <div id="login">

            <loading 
                :active.sync="isLoading" 
                :can-cancel="false" 
                :is-full-page="true"
                class="overlay-load">
            </loading>

            <transition name="fade">
              <div id="step-1" class="multi-step-form active-step" v-if="etapa==='step-1'">
                <div class="d-flex align-content-center">
                  <p><img
                        src="../assets/arrow-left.svg"
                        alt="Voltar etapa"
                        @click.prevent="backtocadastro('step-1')"
                      /></p>
                </div>
                <div class="align-flex-title" style="margin-top: -58px">
                  <h3>Cadastro/Login</h3>
                </div>
                <div>
                  <p style="float: left">CPF:</p>
                  <b-form-input v-model="cpf" placeholder="Digite aqui o seu CPF" v-mask="'###.###.###-##'" @keydown="onKeydown($event)" :class="{ 'statusok-fontbold': cpf.length > 13 }"></b-form-input>
                  <img
                    v-if="cpf.length > 13"
                    class="statusok-check"
                    src="../assets/statusok.svg"
                    alt="Voltar etapa"
                  />
                </div>
                <div>
                  <p style="float: left">Senha:</p>
                  <b-form-input v-model="senha" placeholder="Digite aqui a sua senha" type="password" maxlength="10" :class="{ 'statusok-fontbold': /\d/.test(senha) && senha.length >= 6 && this.senha.length <= 10 }"></b-form-input>
                  <img
                    v-if="/\d/.test(senha) && senha.length >= 6 && this.senha.length <= 10"
                    class="statusok-check"
                    src="../assets/statusok.svg"
                    alt="Voltar etapa"
                  />
                  <small>Sua senha deve conter de 6 a 10 dígitos entre letra(s) e número(s).</small>
                </div>
                <!-- TESTE VALIDAÇÃO -->
                <div v-if="errors.length"> 
                  <b v-for="erro in errors" :key="erro">{{ erro }}</b>                    
                </div> 
                <div style="margin-top: 80px">
                  <b-button class="btn-alianca pesquisar-planos big-btn-cadastro" @click="gotodados()">Continuar</b-button>
                </div>
              </div>
            </transition>
          </div>
        </div>
      </section>
    </main>
  </div>
</template>

<script>
  import Vue from 'vue'
  import VueMask from 'v-mask'
  import fazerLoginUsuario from "../services/fazerLoginUsuario"
  import Loading from 'vue-loading-overlay'
  import store from "../store"
  // import salvarLead from '@/services/salvarLead.js'
  Vue.use(VueMask);

  export default {
    name: 'Login',
    mixins: [],
    components: {
      Loading
    },
    data(){
      return {
        cpf: '',
        senha: '',
        etapa: 'step-1',
        errors: [],
        isLoading: false,
      }
    },
    methods: {
      onKeydown: function(e) {

        if (
          // permite somente numeros
          (e.keyCode >= 48 && e.keyCode <= 57) || (e.keyCode >= 96 && e.keyCode <= 105) ||
          // permite teclas lado direito, esquerdo, delete, backspace, tab e enter
          /^(8|9|13|46|37|39|17)$/.test(e.keyCode) ||
          // permite ctrl+ c,v,x,a,z
          /^(67|86|88|65|90)$/.test(e.keyCode) && e.ctrlKey
        ) return;
        e.preventDefault();
        e.stopPropagation();        
      
      },
      backtocadastro(){
        this.$router.push("cadastrar")
      },  
      async gotodados(){
        this.isLoading = true
      
        if (this.cpf == '' || this.senha == ''){
          this.errors = []
          this.errors.push('Usuário ou senha não preenchidos, por favor verifique!')
        } else {
          let usrretorno = await fazerLoginUsuario(this.cpf.replace('-','').replace('.', '').replace('.', ''), this.senha)
          store.commit("mutAliancaObjLogin", usrretorno)
          if(usrretorno.Status || (usrretorno.Status === false && usrretorno.Mensagem == "009-CPF/CNPJ ou e-mail ja estao cadastrados.(login)")){
            store.commit('mutAliancaObjCadastro', null)
            store.commit('mutAliancaUsrCPF', this.cpf)
            this.$router.push("dados-beneficiario")

            // salvarLead(store.getters.getLeadObj)
          } else {
            this.errors = []
            this.errors.push('Você ja possui cadastro, não foi possivel fazer login, CPF ou senha incorretos, tente novamente')
          }
        }

        this.isLoading = false
      },  
    },
    created() {
      let selectedplanocomprar = store.getters.getAliancaSelectedPlano
      if (selectedplanocomprar != null){
        if (store.getters.getAliancaUsrCPF != null) {
          if (store.getters.getAliancaObjLogin != null) {
            if (store.getters.getAliancaObjLogin.Status) this.$router.push("dados-beneficiario")
          }
        }
        
        this.cpf = store.getters.getAliancaUsrCPF
        this.senha = store.getters.getAliancaUsrSenha

        if(this.cpf != null && this.senha != null){
          this.gotodados();
        } else {
            if (store.getters.getAliancaUsrCPF != null) this.cpf = store.getters.getAliancaUsrCPF
            else this.cpf = ''
            this.senha = ''
          }
      } else {
        this.$router.push("seu-plano")
      }
    }
  }
</script>
